import React from 'react'

export const InfoSection = (props) =>
  <section className='info-section hidden lg:block'>
    {props.children}
  </section>
